import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setRouteSeo } from "../utils/seo";

const pageSeo = {
  "/": {
    title: "Virtual Office, GST & Business Registration | BizSarthi",
    description: "BizSarthi provides PAN-India Virtual Office, GST and Business Registration, accounting, ROC, TDS and compliance support.",
  },
  "/services": {
    title: "Business Registration & Compliance Services | BizSarthi",
    description: "Explore BizSarthi Virtual Office, business setup, GST, accounting, ROC, TDS, tax and ongoing compliance services across India.",
  },
  "/business-setup": {
    title: "Company, LLP & GST Registration Services | BizSarthi",
    description: "Compare Private Limited Company, LLP, Proprietorship, Partnership, GST and other business registration solutions across India.",
  },
  "/private-limited-company-registration": {
    title: "Private Limited Company Registration from ₹4,999 | BizSarthi",
    description: "Premium Private Limited Company incorporation support with dedicated State pages, address-route timelines, statutory estimates, DSC and optional GST or MSME support.",
  },
  "/compliance-services": {
    title: "GST, Accounting, ROC & Tax Compliance | BizSarthi",
    description: "Keep your business compliance ready with GST filing, accounting, bookkeeping, ROC, TDS, income-tax and licence support.",
  },
  "/all-prices": {
    title: "Business Registration & Compliance Prices | BizSarthi",
    description: "View simple starting professional fees for BizSarthi business registration, Virtual Office, GST, compliance, licences and import-export support.",
  },
  "/get-started": {
    title: "Gurugram Virtual Office & Business Support | BizSarthi",
    description: "Request Gurugram-priority Virtual Office, GST, Company, LLP, Trademark or compliance support with scope and charges explained before payment.",
    robots: "noindex, follow, noarchive",
  },
  "/privacy-policy": {
    title: "Privacy Policy | BizSarthi",
    description: "Read how BizSarthi collects, uses and protects information submitted through its website.",
  },
  "/terms-conditions": {
    title: "Terms & Conditions | BizSarthi",
    description: "Read the terms governing BizSarthi professional service enquiries and website use.",
  },
  "/refund-policy": {
    title: "Refund Policy | BizSarthi",
    description: "Read the BizSarthi refund and cancellation policy for professional service engagements.",
  },
  "/disclaimer": {
    title: "Professional Services Disclaimer | BizSarthi",
    description: "BizSarthi is an independent professional service platform. Government or authority approval is never guaranteed.",
  },
};

const noindexPaths = new Set(["/thank-you", "/admin/leads"]);

export const SeoManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/virtual-office")) return;
    if (pathname.startsWith("/private-limited-company-registration/")) return;
    if (pathname.startsWith("/llp-registration")) return;
    if (pathname.startsWith("/trademark-registration")) return;
    if (pathname.startsWith("/proprietorship-registration")) return;
    if (pathname.startsWith("/partnership-registration")) return;
    if (pathname.startsWith("/startup-india-registration")) return;
    if (pathname.startsWith("/registration/")) return;

    if (noindexPaths.has(pathname)) {
      setRouteSeo({
        title: pathname === "/thank-you" ? "Request Received | BizSarthi" : "Secure Lead Viewer | BizSarthi",
        description: "Private BizSarthi workflow page.",
        canonical: `https://bizsarthi.com${pathname}`,
        robots: "noindex, nofollow, noarchive",
      });
      return;
    }

    const seo = pageSeo[pathname];
    if (seo) {
      setRouteSeo({
        ...seo,
        canonical: `https://bizsarthi.com${pathname === "/" ? "/" : pathname}`,
        robots: seo.robots || "index, follow",
      });
    }
  }, [pathname]);

  return null;
};
